import { babel } from '@/packages/vue-i18n'

const REASONS_I18N_PREFIX = 'orders-view.inner.order-parts.reasons.'

export function mapReturningPartReason (id) {
	const key = [id, id.replace(/_/g, '-')].find(k => babel.te(REASONS_I18N_PREFIX + k))
	return {
		id,
		name: key ? babel.t(REASONS_I18N_PREFIX + key) : id
	}
}
